<template>
    <div class="int-join-ms-wrap" v-if="initAt">
        <div class="int-join-top"><a href="javascript:;" @click="btn_mainClick()">메인페이지로 이동</a></div>
        <section class="int-join-ms join-stage" v-if="mode!='joinComp'">
            <div class="join-stage-top">
                <h1>회원가입</h1>
                <ul class="join-location">
                    <li v-if="mode!='joinAgree'"><div class="join-stage"><span class="blind">STEP1. 가입약관동의</span></div></li>
                    <li v-if="mode=='joinAgree'"><div class="join-stage on"><span class="blind">현재단계</span></div><div class="join-stage-txt">STEP1. 가입약관동의</div></li>
                    <li v-if="mode!='joinInfo'"><div class="join-stage"><span class="blind">STEP2. 정보입력</span></div></li>
                    <li v-if="mode=='joinInfo'"><div class="join-stage on"><span class="blind">현재단계</span></div><div class="join-stage-txt">STEP2. 정보입력</div></li>
                    <li><div class="join-stage"><span class="blind">STEP3. 가입완료</span></div></li>
                </ul>
                <div class="entry-txt" v-if="mode=='joinAgree'">이용약관 및 정보 수신에 동의 해주세요.</div>
                <div class="entry-txt" v-if="mode=='joinInfo'">기본 정보를 모두 입력하면 가입이 완료됩니다.</div>
            </div>
            <div class="join-stage-con">
                <template v-if="mode == 'joinAgree'">
                <div class="all-checkbox">
                    <input type="checkbox" id="chk00" v-model="rcptnAgreeInfo.allAgreeAt" @change="rcptnAgreeChange('all')">
                    <label for="chk00" style="margin-left:0px;"><span class="box"></span><span class="label-txt">약관ㆍ정보 수신 모두 동의</span></label>
                </div>
                <h2>이용약관, 개인정보 수집/이용 동의</h2>
                <ul class="join-stage-consent">
                    <li>
                        <input type="checkbox" id="chk01" name="" v-model="rcptnAgreeInfo.tosAgreeAt" @change="rcptnAgreeChange('tos')">
                        <label for="chk01"><span class="box"></span><span class="label-txt"><span class="pc01">(필수)</span> 이용약관 동의</span></label>
                        <button class="btn-f15" @click="openTosAgreePopup();">자세히보기</button>
                    </li>
                    <li>
                        <input type="checkbox" id="chk02" name="" v-model="rcptnAgreeInfo.pcuAgreeAt" @change="rcptnAgreeChange('pcu')">
                        <label for="chk02"><span class="box"></span><span class="label-txt"><span class="pc01">(필수)</span> 개인정보 수집ㆍ이용 동의</span></label>
                        <button class="btn-f15" @click="openPcuAgreePopup();">자세히보기</button>
                        </li>
                    <li>
                        <input type="checkbox" id="chk03" name="" v-model="rcptnAgreeInfo.ptoAgreeAt" @change="rcptnAgreeChange('pto')">
                        <label for="chk03"><span class="box"></span><span class="label-txt"><span class="pc01">(필수)</span> 개인정보 제3자 제공 동의</span></label>
                        <button class="btn-f15" @click="openPtoAgreePopup();">자세히보기</button>
                    </li>
                </ul>
                <div class="join-stage-bottom">
                    <div class="img-com __join-info"><span>설명글 아이콘</span></div>동의하지 않으실 경우 <span class="pc01">서비스 이용이 불가능</span>합니다.
                </div>
                <h2>보육 업무ㆍ회계/세무에 대한 다양한 정보 및 혜택 수신 동의</h2>
                <ul class="join-stage-consent">
                    <li>
                        <input type="checkbox" id="chk04" name="" v-model="rcptnAgreeInfo.smsAgreeAt" @change="rcptnAgreeChange('sms')">
                        <label for="chk04"><span class="box"></span><span class="label-txt">SMS 수신 동의</span></label>
                    </li>
                    <li>
                        <input type="checkbox" id="chk05" name="" v-model="rcptnAgreeInfo.emailAgreeAt" @change="rcptnAgreeChange('email')">
                        <label for="chk05"><span class="box"></span><span class="label-txt">이메일 수신 동의 </span></label>
                    </li>
                </ul>
                </template>

                <template v-if="mode=='joinInfo'">
                    <div class="join-stage-input">
                        <input type="text" placeholder="아이디" title="아이디" v-model="mberInfo.id" maxlength="12" @change="mberInfo.chkId=1;"/>
                        <button class="act" @click="btn_idOvrlpClick">중복확인</button>
                    </div>
                    <div class="join-stage-bottom">
                        <div class="img-com __join-info"><span>설명글 아이콘</span></div>영문,숫자 조합으로 6~12자 이내
                    </div>
                    <div class="join-stage-input">
                        <input type="password" placeholder="비밀번호" title="비밀번호" v-model="mberInfo.password"/>
                    </div>
                    <div class="join-stage-input">
                        <input type="password" placeholder="비밀번호 확인" title="비밀번호 확인" v-model="mberInfo.passwordChk"/>
                    </div>
                    <div class="join-stage-bottom">
                        <div class="img-com __join-info"><span>설명글 아이콘</span></div>8-15자리의 영문/숫자/특수문자를 함께 입력해주세요
                    </div>
                    <div class="join-stage-input">
                        <input type="text" placeholder="성명" title="성명" v-model="mberInfo.mberNm"/>
                    </div>
                    <div class="join-stage-input">
                        <div class="join-stage-box">
                            <select v-model="mberInfo.cttpc1" :disabled="setBtnDisabled('cttpc')">
                                <option>010</option>
                                <option>011</option>
                                <option>016</option>
                                <option>017</option>
                                <option>018</option>
                                <option>019</option>
                            </select>
                            <input type="text" class="mgr10" v-model="mberInfo.cttpc2" maxlength="4" :disabled="setBtnDisabled('cttpc')"/> - 
                            <input type="text" class="mgl10" v-model="mberInfo.cttpc3" maxlength="4" :disabled="setBtnDisabled('cttpc')"/>
                        </div>
                        <button :class="setBtnClass('btn_sendNum')" ref="btn_sendNum" :disabled="setBtnDisabled('btn_sendNum')" @click="btn_crtfctnClick()">인증</button>
                        <button :class="setBtnClass('btn_sendNum')" ref="btn_resendNum" :disabled="setBtnDisabled('btn_resendNum')" @click="btn_crtfctnClick()" style="visibility: hidden;" >재인증</button>
                    </div>
                    <div class="join-stage-input">
                        <input type="text" placeholder="인증번호 입력(3분 이내)" title="인증번호" style="background:#f8f8f8;" v-model="mberInfo.crtfyNum" ref="crtfyNum" maxlength="6" disabled/>
                        <button :class="setBtnClass('btn_crtfy')" ref="btn_crtfy" :disabled="setBtnDisabled('btn_crtfy')" @click="btn_cnfrmNumClick()">확인</button>
                    </div>
                    <div class="join-stage-input mgt20">
                        <input type="text" placeholder="이메일" title="이메일" v-model="mberInfo.email"/>
                    </div>
                </template>
            </div>
            <div class="btn-wrap __btn-join">
                <div class="dp-td"><button class="white" @click="btn_cancelClick()">취소</button></div>
                <div class="dp-td" v-if="mode=='joinAgree'"><button class="red" @click="btn_nextClick()">다음</button></div>
                <div class="dp-td" v-if="mode=='joinInfo'"><button class="red" @click="btn_joinClick()">가입하기</button></div>
            </div>
        </section>
        <section v-if="mode == 'joinComp'">
            <div class="int-join-comp">
                <div class="img-com __icon06"><span>완료 아이콘</span></div>
                <div class="entry-title">회원가입이 완료되었습니다.</div>
                <div class="entry-txt">아이오감에 가입해주셔서 감사합니다!<br>보육인들을 위한 다양한 서비스와 콘텐츠로 보답하겠습니다.</div>
                <div class="btn-wrap mgt80">
                    <button @click="btn_mainClick()"><span>로그인하기</span></button>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    const mixinAgree = {
        data : function(){
            return {
                rcptnAgreeInfo : {
                    allAgreeAt:false,
                    tosAgreeAt:false,//Terms of Service - 서비스 약관(이용약관)
                    pcuAgreeAt:false,//Privacy CollectionㆍUse - 개인정보 수집ㆍ이용
                    ptoAgreeAt:false,//Privacy Third party offer - 개인정보 제3자 제공
                    smsAgreeAt:false,
                    emailAgreeAt:false
                }
            }
        },
        methods : {
            rcptnAgreeChange : function(agreeSe){
                const agreeAt = eval("this.rcptnAgreeInfo." + agreeSe + "AgreeAt");

                if(agreeSe == "all"){
                    for(const key in this.rcptnAgreeInfo){
                        if(key != "allAgreeAt"){
                            this.rcptnAgreeInfo[key] = agreeAt;
                        }
                    }
                }else{
                    let chkCnt = 0;

                    for(const key in this.receptionAgree){
                        if(key != "allAgreeAt"){
                            if(this.rcptnAgreeInfo[key]) chkCnt++;
                        }
                    }

                    if(chkCnt == (Object.keys(this.rcptnAgreeInfo).length-1)){
                        this.rcptnAgreeInfo.allAgreeAt = true;
                    }else{
                        this.rcptnAgreeInfo.allAgreeAt = false;
                    }
                }
            },
            openTosAgreePopup : function(){
                alert('이용약관 팝업');
            },
            openPcuAgreePopup : function(){
                alert('개인정보 팝업');
            },
            openPtoAgreePopup : function(){
                alert('제3자 제공 동의 팝업');
            },
            btn_nextClick: function(){
                if(!(this.rcptnAgreeInfo.tosAgreeAt &&this.rcptnAgreeInfo.pcuAgreeAt &&this.rcptnAgreeInfo.ptoAgreeAt)){
                    this.$toasted.show("이용약관, 개인정보 수집ㆍ이용, 제3자 제공에 대한 안내 모두 동의해주세요.");
                    return false;
                }

                this.mode = 'joinInfo';
            }
        }
    }

    const mixinInfo = {
        data : function(){
            return {
                mberInfo : {
                    mberNm : '',
                    id : '',
                    password : '',
                    passwordChk : '',
                    cttpc1 : '010',
                    cttpc2 : '',
                    cttpc3 : '',
                    cttpc : '',
                    chkCrtfy : false,	//휴대폰 인증 체크
                    crtfyNum : '',
                    email : '',
                    chkId : 1,			//중복 아이디 체크
                }
            }
        },
        methods : {
            validId : function(){   //아이디 유효성 체크
                this.mberInfo.id = this.mberInfo.id.replaceAll(' ', '');

                if(this.mberInfo.id == ''){
                    this.$toasted.show("아이디를 입력해주세요.");
                    return true;
                }

                //한글확인
                const korExp = /([ㄱ-ㅎㅏ-ㅣ가-힣])/i;
                if(korExp.test(this.mberInfo.id)){
                    this.$toasted.show("한글은 입력 불가합니다.\n영문, 숫자조합으로 6~12자 이내로 입력해주세요.");
                    return true;
                }

                const spcExp = /[~!@#$%^&*()_+|<>?:{}]/;
                if(!/^[a-zA-Z]/g.test(this.mberInfo.id) ||
                    spcExp.test(this.mberInfo.id)||
                   this.mberInfo.id.length < 6||
                   this.mberInfo.id.length > 12){
                    this.$toasted.show('영문, 숫자 조합으로 6~12자 이내로 입력해주세요.');
                    return true;
                }

                return false;
            },
            btn_idOvrlpClick : function(){  //아이디 중복확인 클릭
                const _this = this;
                
                if(this.validId()) return false;

                this.axios.post('/i5gam/member/join/idOvrlpChk.act',{
                    id:this.mberInfo.id
                }).then(function(response) {
                    if(response.data.ovrlpAt == "Y"){
                        _this.$toasted.show('이미 사용중인 아이디입니다.');
                    }else{
                        _this.mberInfo.chkId = 0;
                        _this.$toasted.show('사용가능한 아이디 입니다.',{duration:1000,type:"success"});
                    }
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            btn_crtfctnClick : function(){  //인증버튼 클릭
                const _this = this;

                if(this.mberInfo.cttpc2 == '' || this.mberInfo.cttpc3.length == ''){
                    this.$toasted.show('휴대폰번호를 입력해주세요.');
                    return false;
                }

                if(this.mberInfo.cttpc2.search(/^\d{3,4}$/) === -1 || this.mberInfo.cttpc3.search(/^\d{4}$/) === -1){
                    this.$toasted.show("숫자만 입력 가능합니다.");
                    this.mberInfo.cttpc2 = '';
                    this.mberInfo.cttpc3 = '';
                    return false;
                }

                this.phoneJoinMberChk().then(function(joinPssbleAt){//폰번호당 아이디 5개만 가입 가능
                    if(joinPssbleAt == 'Y'){
                        _this.phoneCrtfyNumSend();
                    }else{
                        _this.$toasted.show('입력하신 휴대폰 번호로 가입한 ID가 5개 이상입니다.');
                        return false;
                    }
                }).catch(function (e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            phoneCrtfyNumSend : function(){ //인증번호 전송
                const _this = this;

                this.axios.post('/common/crtfy/phoneCrtfyNumSend.act',{
                    cttpc : this.mberInfo.cttpc1 + "-" + this.mberInfo.cttpc2 + "-" + this.mberInfo.cttpc3,
                    srvcCd : 'SBIW02'
                }).then(function(){
                    this.$toasted.show('인증번호를 발송했습니다. 인증번호가 오지 않으면 입력하신 정보가 정확한지 확인해주세요. 발송된 인증번호는 3분간 유효합니다.', {duraion:1000, type:"info"});
                    this.$refs.btn_sendNum.style.visibility = "hidden";
                    this.$refs.btn_resendNum.style.visibility = "visible";

                    this.$refs.crtfyNum.disabled = false;
                    this.$refs.crtfyNum.focus();
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            phoneJoinMberChk : function(){ 
                const _this = this;

                return new Promise(function (resolve, reject) {
                    _this.axios.post('/i5gam/member/join/phoneJoinMberChk.act',{
                        cttpc : _this.mberInfo.cttpc1 + "-" + _this.mberInfo.cttpc2 + "-" + _this.mberInfo.cttpc3
                    }).then(function(response) {
                        const joinPssbleAt = response.data.joinPssbleAt;
                        resolve(joinPssbleAt);
                    }.bind(this)).catch(function(e) {
                        reject(e);
                    });
                });
            },
            btn_cnfrmNumClick : function(){ //인증번호 확인 버튼
                if(this.mberInfo.crtfyNum == ''){
                    this.$toasted.show('인증번호를 입력하지 않았습니다. 수신한 인증번호를 입력해주세요.');
                    return false;
                }

                const _this = this;
                this.axios.post('/common/crtfy/phoneCrtfyNumCnfrm.act',{
                    crtfyNum: this.mberInfo.crtfyNum,
                    cttpc : this.mberInfo.cttpc1 + "-" + this.mberInfo.cttpc2 + "-" + this.mberInfo.cttpc3,
                    mberNm : this.mberInfo.mberNm
                }).then(function(response) {
                    const crtfyNumChkCode = response.data.crtfyNumChkCode;
                    if(crtfyNumChkCode == '001'){
                        _this.mberInfo.chkCrtfy = true;
                        _this.$toasted.show('인증번호가 일치합니다.',{duration:1000,type:"info"});
                        _this.$refs.crtfyNum.disabled = true;
                        _this.setBtnClass('all');
                    }else if(crtfyNumChkCode == '998'){
                        _this.$toasted.show('인증번호를 발송한 휴대폰 번호와 현재 입력된 휴대폰 번호가 다릅니다.');
                    }else if(crtfyNumChkCode == '999'){
                        _this.$toasted.show('인증번호가 일치하지 않습니다. 입력한 휴대폰번호와 수신한 인증번호를 다시 한번 확인해주세요.');
                        _this.$refs.crtfyNum.focus();
                    }
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            setBtnClass : function(btnSe){
                if(btnSe == 'btn_crtfy'){
                    return this.mberInfo.crtfyNum.length == 6? 'act' : 'deagi'
                }else if(btnSe == 'btn_sendNum'){
                    return this.mberInfo.cttpc2.length > 2 && this.mberInfo.cttpc3.length == 4? 'act' : 'deagi'
                }else if(btnSe == 'all'){
                    this.$refs.btn_crtfy.className = 'deagi';
                    this.$refs.btn_sendNum.className = 'deagi';
                    this.$refs.btn_resendNum.className = 'deagi';
                }
            },
            setBtnDisabled : function(btnSe){
                if(btnSe == 'cttpc'){
                    return this.mberInfo.chkCrtfy;
                }else if(btnSe == 'btn_sendNum'){
                    return this.mberInfo.cttpc2.length > 2 && this.mberInfo.cttpc3.length == 4? false : true;
                }else if(btnSe == 'btn_resendNum'){
                    if(this.mberInfo.cttpc2.length > 2 && this.mberInfo.cttpc3.length == 4){
                        if(this.mberInfo.chkCrtfy) return true;
                        return false;
                    }else{
                        return true;
                    }
                }else if(btnSe == 'btn_crtfy'){
                    return this.mberInfo.crtfyNum.length != 6 || this.mberInfo.chkCrtfy ? true : false;
                }
            },
            validCheck : function(){
                if(this.validId()) return true;

                if(this.mberInfo.chkId != '0'){
                    this.$toasted.show('아이디 중복확인을 해주세요.');
                    return true;
                }

                if(this.mberInfo.password.length > 0){
                    let chk = 0;
                    if(this.mberInfo.password.search(/[0-9]/g) != -1 ) chk ++;
                    if(this.mberInfo.password.search(/[a-z]/ig)  != -1 ) chk ++;
                    if(this.mberInfo.password.search(/[!@#$%^&*()?_~]/g)  != -1  ) chk ++;

                    if((chk < 3) || (this.mberInfo.password.length < 8 || this.mberInfo.password.length > 15)){
                        this.$toasted.show("비밀번호는 영문, 숫자, 특수문자를 포함하여 8~15자로 생성해주세요.");
                        return true;
                    }
                }else{
                    this.$toasted.show("비밀번호를 입력해주세요.");
                    return true;
                }

                if(this.mberInfo.password != this.mberInfo.passwordChk){
                    this.$toasted.show("비밀번호가 일치하지 않습니다.");
                    return true;
                }

                if(this.mberInfo.mberNm == ''){
                    this.$toasted.show("성명을 입력해주세요.");
                    return true;
                }

                if(!this.mberInfo.chkCrtfy){
                    this.$toasted.show("휴대폰 인증을 해주세요.");
                    return true;
                }

                if(this.mberInfo.email == ''){
                    this.$toasted.show("이메일을 입력해주세요.");
                    return true;
                }else{
                    const emailValid = /[0-9a-zA-Z][_0-9a-zA-Z-]*@[_0-9a-zA-Z-]+(\.[_0-9a-zA-Z-]+){1,2}$/;
                    if(!emailValid.test(this.mberInfo.email)){
                        this.$toasted.show("올바른 이메일형식을 입력해주세요.");
                        return true;
                    }
                }

                return false;
            },
            btn_joinClick : function(){
                if(this.validCheck()) return false;

                this.mberInfo.cttpc = this.mberInfo.cttpc1 + '-' + this.mberInfo.cttpc2 + '-' + this.mberInfo.cttpc3;
                const _this = this;
                this.axios.post('/i5gam/member/join/joinProc.act',{
                    mberInfo : this.mberInfo,
                    rcptnAgreeInfo : this.rcptnAgreeInfo
                }).then(function(response) {
                    const joinProcCode = response.data.joinProcCode;
                    if(joinProcCode == '001'){
                        _this.mode = 'joinComp';
                    }
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
        }
    }

    export default {
        name : 'join',
        mixins : [mixinAgree, mixinInfo],
        data : function(){
            return {
                initAt : true,
                mode : 'joinAgree', //joinAgree : 약관동의, joinInfo : 기본정보 입력
            }
        },
        methods: {
            btn_mainClick: function(){
                this.$router.push({ name: 'views.i5gam.index'});
            },
            btn_cancelClick: function(){
                if(this.mode == 'joinAgree'){
                    this.$router.push({ name: 'views.i5gam.index'});
                }else if(this.mode == 'joinInfo'){
                    this.mode = 'joinAgree';
                }
            },
        },
    }
</script>

<style scoped>

</style>